import { render, staticRenderFns } from "./step.vue?vue&type=template&id=5b192096&scoped=true"
import script from "./step.vue?vue&type=script&lang=js"
export * from "./step.vue?vue&type=script&lang=js"
import style0 from "./step.vue?vue&type=style&index=0&id=5b192096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b192096",
  null
  
)

export default component.exports